import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceAccess } from "@/routes/help/workspace-access";

export const Route = createFileRoute("/dashboard/help/workspace-access")({
	component: WorkspaceAccess,
});
